export const iconMap = {
    gmail: "https://www.gstatic.com/images/branding/product/1x/gmail_48dp.png",
    gdrive: "https://ssl.gstatic.com/docs/doclist/images/drive_2022q3_32dp.png",
    sheets: "https://www.gstatic.com/images/branding/product/1x/sheets_48dp.png",
    meet: "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v1/web-32dp/logo_meet_2020q4_color_1x_web_32dp.png",
    forms: "https://www.gstatic.com/images/branding/product/1x/forms_48dp.png",
    ai: "https://www.gstatic.com/lamda/images/favicon_v1_150160cddff7f294ce30.svg",
    buffer: "https://buffer.com/favicon.ico",
    slack: "https://a.slack-edge.com/80588/marketing/img/meta/slack_hash_256.png",
    asana: "https://img.logo.dev/asana.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    mailchimp: "https://mailchimp.com/favicon.ico",
    hubspot: "https://www.hubspot.com/favicon.ico",
    github: "https://github.githubassets.com/favicons/favicon.svg",
    jira: "https://wac-cdn.atlassian.com/assets/img/favicons/atlassian/favicon.png",
    woocommerce: "https://woocommerce.com/wp-content/themes/woo/images/logo-woocommerce.svg",
    shopify: "https://cdn.shopify.com/static/shopify-favicon.png",
    square: "https://square.com/favicon.ico",
    instagram: "https://www.instagram.com/static/images/ico/favicon-192.png/68d99ba29cc8.png",
    twitter: "https://abs.twimg.com/responsive-web/client-web/icon-ios.b1fc727a.png",
    rss: "https://upload.wikimedia.org/wikipedia/en/thumb/4/43/Feed-icon.svg/128px-Feed-icon.svg.png",
    stripe: "https://stripe.com/favicon.ico",
    quickbooks: "https://cdn.simpleicons.org/quickbooks",
    expensify: "https://www.expensify.com/favicon.ico",
    xero: "https://cdn.simpleicons.org/xero",
    greenhouse: "https://www.greenhouse.com/favicon.ico",
    bamboohr: "https://www.bamboohr.com/favicon.ico",
    workday: "https://www.workday.com/favicon.ico",
    calendar: "https://www.gstatic.com/images/branding/product/1x/calendar_48dp.png",
    philipshue: "https://img.logo.dev/philips.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    nest: "https://img.logo.dev/nest.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    zendesk: "https://img.logo.dev/zendesk.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    intercom: "https://img.logo.dev/intercom.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    salesforce: "https://img.logo.dev/salesforce.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    docusign: "https://img.logo.dev/docusign.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    notion: "https://img.logo.dev/notion.so?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    linear: "https://img.logo.dev/linear.app?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    trello: "https://img.logo.dev/trello.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    airtable: "https://img.logo.dev/airtable.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    zapier: "https://img.logo.dev/zapier.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    gong: "https://img.logo.dev/gong.io?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    outreach: "https://img.logo.dev/outreach.io?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    apollo: "https://img.logo.dev/apollo.io?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    marketo: "https://img.logo.dev/marketo.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    gsheet: "https://www.gstatic.com/images/branding/product/1x/sheets_48dp.png",
    gdocs: "https://www.gstatic.com/images/branding/product/1x/docs_48dp.png",
    linkedin: "https://img.logo.dev/linkedin.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    crm: "https://img.logo.dev/salesforce.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    zoom: "https://img.logo.dev/zoom.us?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    mixpanel: "https://img.logo.dev/mixpanel.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    typeform: "https://img.logo.dev/typeform.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    taxjar: "https://img.logo.dev/taxjar.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    facebook: "https://img.logo.dev/facebook.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    google: "https://img.logo.dev/google.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    youtube: "https://img.logo.dev/youtube.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    wordpress: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/98/WordPress_blue_logo.svg/1024px-WordPress_blue_logo.svg.png",
    tiktok: "https://img.logo.dev/tiktok.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    webflow: "https://img.logo.dev/webflow.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    
    // Additional integrations from the images
    supabase: "https://img.logo.dev/supabase.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    paypal: "https://img.logo.dev/paypal.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    gtasks: "https://www.gstatic.com/images/branding/product/1x/tasks_48dp.png",
    invideo: "https://img.logo.dev/invideo.io?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    mysql: "https://img.logo.dev/mysql.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    outlook: "https://img.logo.dev/outlook.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    reddit: "https://img.logo.dev/reddit.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    snowflake: "https://img.logo.dev/snowflake.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    gorgias: "https://img.logo.dev/gorgias.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    monday: "https://img.logo.dev/monday.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    onedrive: "https://img.logo.dev/onedrive.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    pipedrive: "https://img.logo.dev/pipedrive.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    resend: "https://img.logo.dev/resend.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    whatsapp: "https://img.logo.dev/whatsapp.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    attio: "https://img.logo.dev/attio.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    coda: "https://img.logo.dev/coda.io?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    bigquery: "https://img.logo.dev/cloud.google.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    dropbox: "https://img.logo.dev/dropbox.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    figma: "https://img.logo.dev/figma.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    fireflies: "https://img.logo.dev/fireflies.ai?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    sentry: "https://img.logo.dev/sentry.io?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    confluence: "https://img.logo.dev/atlassian.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    postgres: "https://img.logo.dev/postgresql.org?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    affinity: "https://img.logo.dev/affinity.co?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    clickup: "https://img.logo.dev/clickup.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    firebase: "https://img.logo.dev/firebase.google.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    cal: "https://img.logo.dev/cal.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    calendly: "https://img.logo.dev/calendly.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    vercel: "https://img.logo.dev/vercel.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    bitbucket: "https://img.logo.dev/bitbucket.org?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    canva: "https://img.logo.dev/canva.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    discord: "https://img.logo.dev/discord.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    lemlist: "https://img.logo.dev/lemlist.com?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    instantly: "https://img.logo.dev/instantly.ai?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    telegram: "https://img.logo.dev/telegram.org?token=pk_acnHOju_S3KawCcUE6Ek2Q",
    upgraded: "/upgraded-collapsed-logo.png",
  };